import { makeStyles } from '@material-ui/core';
import { calculateHeight, calculateWidth, rem, vh, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';
import { hSpacing } from '../../../common/helpers/config';

export const styles = makeStyles(theme => ({
  actionButtonsContainer: {
    margin: '0 0 auto',
    flex: '1 1 auto',
  },
  buttonsContainer: {
    display: 'flex',
    flex: '0 1 auto',
    justifyContent: 'space-between',
    paddingRight: hSpacing,
    '& > div': {
      marginLeft: hSpacing,
      flexGrow: 1,
    },
  },
  buttonsContainerSmallForm: {
    display: 'flex',
    flex: '0 1 auto',
    justifyContent: 'start',
    paddingRight: hSpacing,
    '& > div': {
      marginLeft: hSpacing,
      flexGrow: 0,
      width: '100%',
    },
  },
  button: {
    boxShadow: 'none',
    border: `1px solid ${themeColor.secondaryLight}`,
    width: '100%',
    padding: '10px',
    '@media (max-width: 1365px)': {
      padding: '10px 5px',
    },
  },
  moreButton: {
    boxShadow: 'none',
    border: `1px solid ${themeColor.secondaryLight}`,
    width: '100%',
    padding: '10px',
    '@media (max-width: 1365px)': {
      padding: '10px 5px',
    },
  },
  moreButtonSmallForm: {
    boxShadow: 'none',
    border: `1px solid ${themeColor.secondaryLight}`,
    width: vw(13.28125),
    padding: '10px',
    '@media (max-width: 1365px)': {
      padding: '10px 5px',
    },
  },
  buttonStartIcon: {
    marginLeft: 'inherit',
    marginRight: '10px',
    height: '3.125vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.info.main,
    '@media (max-width: 1365px)': {
      marginRight: '5px',
    },
  },
  buttonLabel: {
    justifyContent: 'normal',
  },
  buttonLabelSmallForm: {
    justifyContent: 'center',
  },
  buttonText: {
    fontWeight: 500,
    lineHeight: rem(1),
    letterSpacing: '0.5px',
    textAlign: 'left',
    overflow: 'hidden',
    fontSize: rem(0.75),
    textOverflow: 'ellipsis',
    maxHeight: 'calc(7.29vh - 20px)',
  },
  buttonTextSmallForm: {
    fontWeight: 500,
    lineHeight: rem(1),
    letterSpacing: '0.5px',
    textAlign: 'center',
    overflow: 'hidden',
    fontSize: rem(0.75),
    textOverflow: 'ellipsis',
    maxHeight: 'calc(7.29vh - 20px)',
  },
  buttonSmallFormIcon: {
    color: theme.palette.info.main,
    width: '2em',
    height: '2.5em',
    maxHeight: '6.25vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      height: '1.5em',
      maxWidth: '2.34vw',
      maxHeight: '3.25vh',
    },
  },
  buttonSelected: {
    borderColor: theme.palette.secondary.main,
    borderWidth: '.2em',
    borderStyle: 'solid',
  },
  moreButtonContainerMargin: {
    marginTop: calculateHeight(10).stringValue,
  },
  moreButtonContainer: {
    flex: '0 0 auto',
  },
  moreLabel: {
    fontSize: rem(0.75),
    fontWeight: 500,
    letterSpacing: vw(0.0366),
    lineHeight: 1.14285,
    textAlign: 'left',
  },
  moreIcon: {
    margin: 0,
    marginLeft: calculateWidth(4).stringValue,
    marginRight: calculateWidth(4).stringValue,
    height: vh(3.25),
    width: vh(3.25),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      height: '100%',
      width: '100%',
    },
  },
  nevigateIcon: {
    bottom: 0,
    right: 0,
    position: 'absolute',
    width: vh(1),
    height: vh(1),
    borderWidth: vh(0.3),
    borderStyle: 'none solid solid none',
    borderColor: '#5D6B72',
    marginRight: calculateWidth(2).stringValue,
    marginBottom: calculateWidth(2).stringValue,
  },
}));
